import React, {Component} from 'react';

import Link from '../../../shared/components/hyperlink';
import AdaptiveImage from '../../../shared/components/adaptive-image';

import './content-carousel-card.less';

import Button from '../../../ui/components/button';
import Dotdotdot from 'react-dotdotdot';


class ContentCarouselCard extends Component {

  static defaultProps = {
    thumbnail: {
      src: null,
      alt: 'HPImage',
      title: 'HPImage',
    }
  }

  render() {

    let {thumbnail={}, title="", vanityUrl=""} = this.props;

    let thumbnailType = thumbnail.constructor.toString();
    if(thumbnailType.indexOf('Object') < 0){
      thumbnail= {
         src: thumbnailType.indexOf('Array') < 0 ? thumbnail : thumbnail[0],
         alt: 'HPImage',
         title: 'HPImage',
      }
    }
    return (
      <div className='content-carousel-element-container'>
      <Link to={`/${vanityUrl}`}>
          <div className='content-carousel-element'>
            <AdaptiveImage
              className="content-carousel-image" 
              src={thumbnail.src} 
              alt={thumbnail.alt} 
              title={thumbnail.title} 
              lazyload={true}
              maxWidth={370}
            />
          <div className="content-carousel-article-title"><Dotdotdot clamp={3}><span>{title}</span></Dotdotdot></div>
          <Button text="READ MORE" className="with-hover primary" color="dark" action="go" size="small" color="dark"/>
        </div>
        </Link>
      </div>
    )
  }
}

export default ContentCarouselCard;
